import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthenticateDomainService } from 'src/app/private/services/authenticate-domain.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';

@Component({
  selector: 'app-add-email-to-domain',
  templateUrl: './add-email-to-domain.component.html',
  styleUrls: ['./add-email-to-domain.component.scss']
})
export class AddEmailToDomainComponent {
  domain = '';
  @Input() selectedDomain: any;
  @Output() close = new EventEmitter<void>();

  primaryName: string = '';
  primaryNameError: string = '';

  otherEmailNames: string[] = [''];
  otherEmailErrors: string[] = [''];

  btnLoading: boolean = false;

  private nameRegex = /^[a-zA-Z0-9._-]+$/; // only alphanumeric and ., _, -

  constructor(
    private toastr: ToastrService,
    private localStorage: LocalStorageService,
    private api: AuthenticateDomainService
  ) {
  }

  ngOnInit() {
    console.log('Selected Domain:', this.selectedDomain);
    if (this.selectedDomain) {
      console.log('Selected Domain:', this.selectedDomain);
      this.domain = '@' + this.selectedDomain.domain;
    } else {
      this.toastr.error('No domain selected');
      this.close.emit();
    }
  }

  validatePrimaryName() {
    if (!this.primaryName.match(this.nameRegex)) {
      this.primaryNameError = 'Special characters not allowed. Must be a valid email username.';
    } else {
      this.primaryNameError = '';
    }
  }

  validateOtherName(index: number) {
    if (!this.otherEmailNames[index].match(this.nameRegex)) {
      this.otherEmailErrors[index] = 'Special characters not allowed. Must be a valid email username.';
    } else {
      this.otherEmailErrors[index] = '';
    }
  }

  isPrimaryValid(): any {
    return this.primaryName && !this.primaryNameError;
  }

  submitEmailForm() {
    this.validatePrimaryName();
    this.otherEmailNames.forEach((_, i) => this.validateOtherName(i));

    const anyOtherError = this.otherEmailErrors.some(error => !!error);
    if (this.primaryNameError || anyOtherError) return;

    this.btnLoading = true;

    const payload = {
      primary_email: this.primaryName + this.domain,
      other_emails: this.otherEmailNames
        .filter(name => !!name)
        .map(name => name + this.domain),
      client_id: this.localStorage.getClientId(),
    };

    this.api.verifyDomainEmail(payload).subscribe({
      next: (response) => {
        this.btnLoading = false;
        this.toastr.success('Email added successfully');
        this.close.emit();
      },
      error: (error) => {
        this.btnLoading = false;
        console.error('Error adding email:', error);
        this.toastr.error('Error adding email');
      }
    });


  }

  addEmail() {
    this.otherEmailNames.push('');
    this.otherEmailErrors.push('');
  }

  removeEmail(index: number) {
    this.otherEmailNames.splice(index, 1);
    this.otherEmailErrors.splice(index, 1);
  }

  closeModal() {
    this.close.emit();
  }

  trackByIndex(index: number, item: any): number {
  return index;
}

}
